import FixScroll  from '../helpers/FixScroll'
import Tutorial from "./Tutorial";

class Preloader {
  constructor() {
    // if(window.location.href.includes('?url')) {
    //   document.body.classList.remove('has-preloader')
    //   document.querySelector('.js-preloader').remove()
    //   document.body.classList.add('preloader-done')
    // } else {
    //   this.createPreloader()
    //   this.initialize()
    // }
    this.initialize()
    this.createPreloader()

  }

  initialize() {
    this.windowRef = window.location.href
    this.preloader = document.querySelector('.js-preloader')
    this.preloader.classList.add('start-animation')
    this.provider = localStorage.getItem('single')    
    this.preloaderText = this.preloader.getAttribute('data-preloader-text')
    FixScroll.fix()
    if(this.provider == 'artist' || this.provider == 'artworks') {
      this.preloader.classList.add('preloader--dark')
    }

    this.bindEvents()
  }

  createPreloader() {
    let preloader

    if (document.querySelector('.js-preloader')) {
      preloader = document.querySelector('.js-preloader')
    } else {
      preloader = document.createElement('div')
      preloader.className = 'preloader u-flex u-flex-center js-preloader'
    }

    preloader.innerHTML = `<div>
              <div class="cell-start-0 cell-end-4">
                  <div class="preloader__loader" role="alert">
                      <div class="preloader__loader__circle">
                          <svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" width="180" height="180">
                              <circle class="circle-chart__circle" stroke-dasharray="50, 100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                              <circle class="circle-chart__circle__second" stroke-dasharray="50, 100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                          </svg>
                      </div>
                      <div class="preloader__loader__inner">
                          <svg viewBox="0 0 494.5 138.3"><path d="M1.5 2.7h64.2c55.2 0 76.8 32.4 76.8 66.7 0 34.9-27.7 66-80.4 66H1.6c-1.1 0-1.5-.7-1.5-1.3 0-.7.7-1.3 1.7-1.3h11.3c3.5 0 5.8-2.1 5.8-6V11.5c0-2.9-1.4-6.1-6-6.1H1.4C.5 5.4 0 4.8 0 4.1c0-.6.2-1.4 1.5-1.4m40.1 126.5c0 2.9 1.3 3.8 3.2 3.8h17c41.9 0 57.1-32.1 57.1-64.3S102.8 5.3 67.4 5.3H44.3c-2.4 0-2.6 2-2.6 2.9l-.1 121zM148.9 2.7c-1 0-1.9.4-1.9 1.2 0 .8.5 1.3 1.4 1.3h11.3c2.6 0 5.1 1.8 5.1 6.8v114.9c0 2.4-1.8 6-5 6h-11.2c-1.3 0-1.4 1-1.4 1.4 0 .4-.1 1.1 1.4 1.1H203c.8 0 1.9-.1 1.9-.9s-.2-1.6-1.6-1.6h-10.5c-1.5 0-5.6-.9-5.6-5.5V10.8c0-3.3 2.1-5.5 5.9-5.5h10.3c.9 0 1.4-.5 1.4-1.2s-.5-1.3-1.7-1.3h-54.2zm85 66.4c0-36.7 16.4-66.4 47.2-66.4 30.2 0 47.2 29.7 47.2 66.4s-15.5 66.4-47.2 66.4c-30.7.1-47.2-29.7-47.2-66.4m47.2 69.2c43.8 0 71.4-31 71.4-69.1S325.2 0 281.1 0c-44 0-71.4 31-71.4 69.1s28.5 69.2 71.4 69.2m211.4-3.7c-17.2 1.8-26.7-26.4-35.4-39.8-6.5-9.9-20.3-20-33.9-22 22.4-1.3 47.5-8.5 47.5-33.9 0-20.6-12.7-36.2-59.3-36.2h-53.7c-.7 0-1.4.4-1.4 1.2 0 .8.7 1.3 1.4 1.3H370c2.6 0 5.1 1.8 5.1 6.8v114.9c0 2.4-1.8 6-5 6H358c-1 0-1.4.8-1.4 1.2s.4 1.3 1.4 1.3h57c.8 0 1.5-.4 1.5-1.2 0-.8-.5-1.3-1.6-1.3h-11.5c-1.5 0-5.6-1-5.6-5.5V73.1h5.9c28.2 0 30.3 30.6 44.3 48.1 12 15 27.7 16.9 36.6 16.9 3.8 0 6.4-.1 8.8-.7 1.5-.5 1.8-3.1-.9-2.8m-89-129.4h8.3c14.2 0 37.2 5.6 37.2 32.4 0 24.6-20.4 32.9-39.3 32.9h-12.1V10.8c0-3.4 2.1-5.6 5.9-5.6"></path></svg>
                          <p class="body body--smd mt-4 u-upper">New York</p>
                      </div>
                  </div>
              </div>
              <div class="preloader__text">
                 <p>${this.preloaderText}</p>
              </div>
          </div>`

    if (!document.querySelector('.js-preloader')) {
      document.body.prepend(preloader)
    }

    // Ajouter les attributs d'accessibilité selon Code Accessible
    preloader.setAttribute('aria-hidden', 'false')
    preloader.setAttribute('tabindex', '-1')
    
    // Désactiver le scroll pendant le chargement
    document.body.style.overflow = 'hidden'
  }

  bindEvents() {
    window.addEventListener('fetch:done', this.onDone.bind(this))
  }

  onDone() {
    if (this.preloader) {
      setTimeout(() => {
        // Masquer le preloader pour l'accessibilité
        this.preloader.setAttribute('aria-hidden', 'true')
        
        // Réactiver le scroll
        document.body.style.overflow = 'auto'
        
        this.preloader.classList.add('is-invisible')
        document.body.classList.remove('has-preloader')
        FixScroll.unFix()
      }, 2800)

      setTimeout(() => {
        this.preloader.remove()
      }, 3000)

      setTimeout(() => {
        document.body.classList.add('preloader-done')
      }, 5300)
    }
  }
}

export default Preloader
